import translations from './translations'
import { state } from '../lib/state'

module.exports = string => {
  const { language } = state

  const translation = translations[string]

  if (language && translation && translation[language]) {
    return translation[language]
  }

  return string
}